
import React from 'react';
import cn from 'classnames';

import styles from './StatusBoxComponent.module.scss';

export default function StatusBoxComponent(props) {
  return (
    <div  id="status_Data_block1" className={`sdddcom ${cn(styles.flex, styles.flex_layout)}`}>
      <div  id="status_Data_Img" style={{ '--src': `url(${props.img})` }} className={cn(styles.box5, styles.box5_layout)} />

      <div  id="status_Data_block2" className={cn(styles.block7, styles.block7_layout)}>
        <div  id="status_Data_Value" className={cn(styles.text_body, styles.text_body_layout)}>
          {props.value}
        </div>
        <div  id="status_Data_unit" className={cn(styles.text_body1, styles.text_body1_layout)}>
          {props.title}
        </div>
      </div>
    </div>
  );
}

StatusBoxComponent.inStorybook = true;


